import { render, staticRenderFns } from "./races.vue?vue&type=template&id=a387119e&scoped=true&"
import script from "./races.vue?vue&type=script&lang=js&"
export * from "./races.vue?vue&type=script&lang=js&"
import style0 from "./races.vue?vue&type=style&index=0&id=a387119e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a387119e",
  null
  
)

export default component.exports